import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MaterialModule } from '../../app/material.module';
import { CommonModule } from '@angular/common';
import {
  OrganizationRiderDetail,
  OrganizationRiderService,
  OrganizationRiderServiceLevel,
  OrganizationService,
  OrganizationServiceLevel,
  RideLimitDetail
} from '@uzurv/clara';
import { map } from 'rxjs';
import { DateFormatConstants, isNullOrUndefined, UzurvPipesModule } from '@uzurv/core';
import moment from 'moment';
import { RequiresPermissionsModule } from '../directives/requires-permissions';

@Component({
  selector: 'app-organization-rider-profile',
  templateUrl: './organization-rider-profile-component.html',
  styleUrls: ['./organization-rider-profile-component.scss'],
  standalone: true,
  imports: [MaterialModule, CommonModule, UzurvPipesModule, RequiresPermissionsModule]
})
export class OrganizationRiderProfileComponent implements OnInit, OnChanges {
  @Input() organizationRiderDetail: OrganizationRiderDetail;
  @Output()
  editOrganizationRiderInfo = new EventEmitter<
    [OrganizationRiderDetail, Array<OrganizationRiderServiceLevel>, Array<OrganizationServiceLevel>]
  >();

  @Output() eligibilityToggleChanged = new EventEmitter<boolean>();

  organizationServiceLevels: Array<OrganizationServiceLevel>;

  organizationRiderPhoneNumber: string;

  inEligibleRiderClass: string;

  organizationRiderServiceLevels: Array<OrganizationRiderServiceLevel>;

  constructor(private organizationRiderService: OrganizationRiderService, private organizationService: OrganizationService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['organizationRiderDetail']) {
      this.organizationRiderServiceLevels = [...this.organizationRiderDetail.organizationRiderServiceLevels];
      this.fetchOrganizationServiceLevels();
      this.inEligibleRiderClass = this.organizationRiderDetail.eligible ? null : 'warning-text';
    }
  }
  ngOnInit(): void {}

  fetchOrganizationServiceLevels() {
    this.organizationService
      .listOrganizationServiceLevels(this.organizationRiderDetail.organizationId)
      .pipe(
        map(osl => {
          this.organizationServiceLevels = osl;

          this.organizationServiceLevels.map(osl => {
            const existingOrganizationRiderServiceLevel = this.organizationRiderServiceLevels?.find(
              orsl => orsl.serviceLevel.code === osl.serviceLevel.code
            );

            if (isNullOrUndefined(existingOrganizationRiderServiceLevel)) {
              const organizationRiderServiceLevel = new OrganizationRiderServiceLevel();
              organizationRiderServiceLevel.serviceLevel = osl.serviceLevel;
              organizationRiderServiceLevel.enabled = osl.optional ? false : true;

              this.organizationRiderServiceLevels.push(organizationRiderServiceLevel);
            }
          });
        })
      )
      .subscribe();
  }

  formatShortDate(date: Date): string {
    return moment(date).format(DateFormatConstants.SHORT_MONTH_ORDINAL_DAY);
  }

  getFormattedDateOfBirth(dateOfBirth: Date): string {
    if (isNullOrUndefined(dateOfBirth)) {
      return null;
    }

    return moment(dateOfBirth).format(DateFormatConstants.DATE_OF_BIRTH);
  }

  handleEditOrganizationRiderInfo() {
    this.editOrganizationRiderInfo.emit([
      this.organizationRiderDetail,
      this.organizationRiderDetail.organizationRiderServiceLevels,
      this.organizationServiceLevels
    ]);
  }

  handleEligibilityToggleClicked(event: any) {
    this.eligibilityToggleChanged.emit(event.checked);
  }
}
